import styled from "styled-components";


export const PageFooter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 20vh;
  background-color: #adadadcc;
`

export const ItemsContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 12%;
`

export const Logo = styled.img`
    width: 2.8rem;
    height: 2.8rem;
`